import BaseApi from "./baseApi";
import type { IdLike } from "../types";

class PerishApi extends BaseApi {
  async addPerish(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/perish/addperish",
      data: data,
      method: "post",
    });
  }

  /** Password-gated or JWT create used by projected retreat registration. */
  async addPerishWithRegistrationAccess(
    data: Record<string, unknown> | object,
  ): Promise<any> {
    return await this.API({
      url: "/auth/addperish",
      data: data,
      method: "post",
    });
  }
  // async getPerishList(data) {
  //   return await this.API({
  //     url: "/perish/getallperishlist",
  //     method: "get",
  //   });
  // }

  async getAllPerishSearch(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/perish/getAllPerishSearch",
      data: data,
      method: "post",
    });
  }

  async deletePerish(data: Record<string, unknown> | object, service_id: IdLike): Promise<any> {
    return await this.API({
      url: `/perish/deleteperish/${service_id}`,
      data: data,
      method: "delete",
    });
  }

  async searchKey(data: Record<string, unknown> | object, key: string): Promise<any> {
    return await this.API({
      url: `/perish/search/${key}`,
      method: "get",
    });
  }

  async updatePerish(data: Record<string, unknown> | object, service_id: IdLike): Promise<any> {
    return await this.API({
      url: `/perish/updateperish/${service_id}`,
      data: data,
      method: "put",
    });
  }
}

export default PerishApi;
